import http from './http'

export function listAccounts() {
  return http.get('/social/accounts')
}

export function getAccount(id) {
  return http.get(`/social/accounts/${id}`)
}

export function connectPlatform(platform) {
  return http.post(`/social/${platform}/connect`)
}

export function connectInstagramToken(accessToken) {
  return http.post('/social/instagram/connect-token', { access_token: accessToken })
}

export function disconnectAccount(id) {
  return http.delete(`/social/accounts/${id}`)
}
